// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"MonitorToggleButton-toggleButton-3CcN9 IconButton-button-2qiGi Link-link-1rgM9","isDisabled":"MonitorToggleButton-isDisabled-1NwSX"};